<template>
<div class="chapter">
<div class="inner_page">
<div class="image_container">
<img alt="image" src="images/f0008-01.jpg"/>
<p class="source"><a id="page_8">(Courtesy of Railway Magazine)</a></p><a id="page_8">
</a></div><a id="page_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Map.vue?b0d3bcd2